export { default as supportCardLocaleEs } from './localeEs';
export { default as supportCardLocalePt } from './localePt';
export { default as supportCardLocaleEn } from './localeEn';
